import { OK } from "http-status-codes";
import { API, buildQueryParams, get, post, remove, downloadFile } from "api/api";
import { AdMaterialDetails, Permission } from "api/creatives";

export type AssetType = "DEFAULT" | "VISUAL" | "FILTER" | "CLASSIFIEDHEADER" | "CLASSIFIEDCONTINUATION";

export interface AssetRes {
    assigned: boolean;
    bigpreview?: AdMaterialDetails;
    creationdate: string;
    current: boolean;
    deleted: boolean;
    height: string;
    id: number;
    inputfilename: string;
    mimetype: string;
    modificationdate: string;
    name: string;
    originalfile: AdMaterialDetails;
    permissions: Permission[];
    preview?: AdMaterialDetails;
    processing: boolean;
    products: [];
    size: string;
    status: string;
    valid: boolean;
    width: string;
    type: AssetType;
}

export const getMaterialSpecAssetsReq = async (headers: HeadersInit, materialSpecId?: number, materialId?: number) => {
    const queryParams = buildQueryParams({ matspec: materialSpecId, admaterial: materialId });
    const { parsedBody } = await get<AssetRes[]>(`${API.baseApiUrl}/assets?${queryParams}`, { headers });

    return parsedBody || [];
};

export const uploadAssetReq = async (headers: HeadersInit, formData: FormData) => {
    const { parsedBody } = await post<AssetRes[]>(
        `${API.baseApiUrl}/assets`,
        formData,
        {
            headers,
        },
        false
    );

    return parsedBody || [];
};

export const downloadAssetReq = async (headers: HeadersInit, assetId: number) => {
    await downloadFile(`${API.baseApiUrl}/assets/download?asset=${assetId}`, { headers });

    return OK;
};

export const deleteAssetReq = async (headers: HeadersInit, id: number) => {
    await remove(`${API.baseApiUrl}/assets?asset=${id}`, { headers });

    return id;
};

export const submitAssetReq = async (headers: HeadersInit, materialSpecId: number, complete = false) => {
    const queryParams = buildQueryParams({ matspec: materialSpecId, complete });
    await post(`${API.baseApiUrl}/assets/submit?${queryParams}`, null, { headers });

    return OK;
};
